// frontend/src/useIsMobile.ts


import { useEffect, useState } from "react";

export function useIsMobile(breakpoint: number = 768) {
   const [isMobile, setIsMobile] = useState<boolean>(
      () => typeof window !== "undefined" && window.innerWidth < breakpoint
   );

   useEffect(() => {
      const handleResize = () => {
         setIsMobile(window.innerWidth < breakpoint);
      };

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
   }, [breakpoint]);

   return isMobile;
}
